import { useEffect, useRef, useState } from "react";

export const useLayerPresence = (layers, duration) => {
  const shownRef = useRef([]);
  const leavingRef = useRef(new Map());
  const [, setTick] = useState(0);

  const keys = new Set(layers.map((layer) => layer.key));
  shownRef.current.forEach((layer, index) => {
    if (!keys.has(layer.key) && !leavingRef.current.has(layer.key)) {
      leavingRef.current.set(layer.key, { layer, index });
    }
  });
  layers.forEach((layer) => leavingRef.current.delete(layer.key));
  shownRef.current = layers;

  const leavingKey = [...leavingRef.current.keys()].join("|");
  useEffect(() => {
    if (!leavingKey) return undefined;
    const timer = setTimeout(() => {
      leavingRef.current.clear();
      setTick((count) => count + 1);
    }, duration);
    return () => clearTimeout(timer);
  }, [leavingKey, duration]);

  const leaving = [...leavingRef.current.values()]
    .sort((first, second) => first.index - second.index)
    .map(({ layer }) => ({ location: layer, leaving: true }));
  return [...layers.map((layer) => ({ location: layer, leaving: false })), ...leaving];
};
